<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-17 15:39:06
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/cart/components/CantProduct/index.vue
-->
<template>
  <div class="con_pro_cant" @click="goProductDetail(item.spuId)">
    <div class="cant_bug font10 font_weight400 colof line_height_22">
      失效
    </div>
    <img :src="item.skuPic" alt="" class="product_img" />
    <div class="name_con">
      <div
        class="name_title font12 font_weight400 colo087 font_line_2 text_left line_height_17"
      >
        {{ item.skuName }}
      </div>
      <!-- 规格 -->
      <div class="name_spec font10 font_weight400 colo055 text_left">
        规格：{{ item.skuSpec }}
      </div>
      <!-- 价格 -->
      <div class="name_price">
        <div class="font16 font_weight600 colo087 line_height_19 look_price">
          {{ item.price | currency(false) }}
        </div>
        <!-- <div
          class="font10 font_weight500 colof look_as line_height_24"
          @click="lookAsProduct"
        >
          看类似
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      value: ""
    };
  },
  methods: {
    lookAsProduct() {
      this.$emit("lookAsProduct");
    },
    goProductDetail(spuId) {
      this.$emit("goProductDetail", spuId);
    }
  }
};
</script>
<style lang="less" scoped>
.con_pro_cant {
  display: flex;
  align-items: flex-start;
  width: 100%;
  box-sizing: border-box;
  padding: 0 12px 24px 0;
  .cant_bug {
    flex-shrink: 0;
    background: rgba(0, 0, 0, 0.38);
    border-radius: 2px;
    padding: 0 4px;
    margin: 37px 8px 0;
  }
  .product_img {
    width: 96px;
    height: 96px;
    flex-shrink: 0;
    object-fit: cover;
    border-radius: 4px;
    background-color: #f5f5f5;
  }
  .name_con {
    flex: 1;
    min-width: 0;
    margin-left: 12px;
    .name_title {
      width: 100%;
    }
    .name_spec {
      margin-top: 4px;
    }
    .name_price {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .look_price {
        margin-top: 5px;
      }
      .look_as {
        background: #ff0022;
        border-radius: 12px;
        padding: 0 14px;
      }
    }
  }
}
</style>
